import moment from 'moment-timezone';

import {hasValue} from '@famly/stat_ts-utils_has-value';

interface TimeMapToDecimalHoursPayload {
    hours?: number;
    minutes?: number;
}

/**
 *
 * @param hoursInDecimal: 7.5 for example
 * (hoursInDecimal % 1) => takes the thing after the `.` so if you have 7.5 -> you will get 0.5
 * Then you multiple by 60 to normalize for minutes values and 0.5 becomes 35.9999
 * Then you floor the bad boy to get a clean 35 mins
 *
 * @returns returns {hours: 7, minutes: 30}
 */
export const decimalHoursToTimeMap = (hoursInDecimal: number | null): {hours: number; minutes: number} | undefined => {
    if (!hasValue(hoursInDecimal)) {
        return undefined;
    }

    if (hoursInDecimal < 0) {
        return undefined;
    }

    const hours = Math.floor(hoursInDecimal);
    const minutes = Math.round((hoursInDecimal % 1) * 60);
    return {hours, minutes};
};

/**
 *
 * @param hours: 7 for example
 * @param minutes: 30 for example
 * reverse process of the decimalHoursToTimeMap
 * @returns returns 7.5
 */
export const timeMapToDecimalHours = ({hours, minutes}: TimeMapToDecimalHoursPayload): number => {
    if (!hasValue(hours) && !hasValue(minutes)) {
        return -1;
    }

    const totalHours = moment
        .duration({
            hours,
            minutes,
        })
        .asHours();

    return totalHours;
};
